import { HttpClient } from '@angular/common/http';
import { CacheService } from '../cache';
import { ResourceService } from './resource';
import { Admin, IAdmin } from '../../models/admin';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '../../models';
import { ACCOUNT_STATUS } from '../../models/user';

@Injectable({
  providedIn: 'root'
})
export class AdminService extends ResourceService<Admin> {

  /**
   * @constructor
   * Creates an instance of the AdminService
   *
   * @param {HttpClient} http Injected instance of HttpClient
   * @param {CacheService} cache Injected instance of CacheService
  */
  constructor(
    protected http: HttpClient,
    protected cache: CacheService
  ) {
    super(http, cache, 'admins');
  }

  /**
  * Sends a POST request to the /admins/:id/password endpoint of the typed Resource
  * @remarks
  *  to allow change of passowrd
  *
  * @param {string} id unique identifier of selected user
  * @param {any} data: body of request sent to the server
  * @returns {Observable} Returns an observable of array of typed Resources, with a server-side representations of the matching resources
  */
  change_password(id: string, data: any) {
    return this.http.post<IAdmin>(`${this.endpoint}/${id}/password`, data)
  }

  /**
    * Sends a PUT request to the /admins/:id/blocked endpoint of the typed Resource
    * @remarks
    * to toggle a user providing property(s) on Clooper trusted or untrusted
    * @param {string} id: unique identifier of the admin
    * @param {any} data: body of request made to the endpoint
    * @returns {Observable} Returns an observable of object
  */
   toggle_block_admin(item: { id: string, blocked: boolean }) {
    return this.http.put<Admin>(`${this.endpoint}/${item.id}/blocked`, item).pipe(map(resp => {
      this.cache.remove(`${this.endpoint}/${item.id}`);
      this.cache.remove(`${this.endpoint}`);
      return resp.data.admin;
    }))
  }

  /**
    * Sends a PUT request to the /admins/blocked endpoint of the typed Resource
    * @remarks
    * to toggle a user providing property(s) on Clooper trusted or untrusted
    * @param {string} ids: unique identifier of the user
    * @param {any} data: body of request made to the endpoint
    * @returns {Observable} Returns an observable of object
  */
   bulk_toggle_block_admins(data: { id?: string, ids?: string[], blocked: boolean }): Observable<any> {
    return this.http.put(`${this.endpoint}/blocked`, data).pipe(map(resp => {
      data.ids?.forEach(id => this.cache.remove(`${this.endpoint}/${id}`));
      this.cache.remove(`${this.endpoint}`);
      return resp;
    }))
  }
  updateAccountStatus(id: string, status: ACCOUNT_STATUS): Observable<User> {
    return this.http.put< User>(`${this.endpoint}/${id}/account-status`, {
      account_status: status
    }).pipe(
      map((response: any) => {
        const updatedUser = response?.data?.user || response;

        this.cache.remove(`${this.endpoint}/${id}`);
        this.cache.remove(`${this.endpoint}`);

        return updatedUser;
      })
    );
  }

}
